import { Rectangle } from '@styled-icons/boxicons-regular';
import { useExpandedScreenContext } from '@/shared/ThemeDetail/ExpandedScreen/ExpandedScreenContext';
import { useContext } from 'react';
import { FullscreenContext } from '@/shared/FullscreenContext/FullscreenContext';
import { StyledExpandedScreenButton } from './ExpandedScreenButton.styled';

export default function ExpandedScreenButton({ className = '' }) {
  const fullscreenContext = useContext(FullscreenContext);
  const expandedScreenContext = useExpandedScreenContext();

  return expandedScreenContext.state &&
    !fullscreenContext.state.isFullscreen ? (
    <StyledExpandedScreenButton
      onClick={() => {
        expandedScreenContext.actions.toggle();
      }}
      size="small"
      className={`${
        expandedScreenContext.state.active ? 'active' : ''
      } ${className} expanded-screen-button`}
    >
      <Rectangle size={18} className="expanded-screen-icon" />
    </StyledExpandedScreenButton>
  ) : null;
}
